document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-nav li");
  const panels = document.querySelectorAll(".tab-panel");
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      tabs.forEach((t) => t.classList.remove("active"));
      panels.forEach((panel) => panel.classList.remove("active"));
      tab.classList.add("active");
      panels[index].classList.add("active");
    });
  });

  const mobileTabs = document.querySelectorAll(".tab-nav-mobile li");

  mobileTabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const contentId = tab.dataset.tab;
      const content = document.getElementById(contentId);
      const isActive = tab.classList.contains("active");
      mobileTabs.forEach((t) => t.classList.remove("active"));
      document.querySelectorAll(".tab-content-mobile").forEach((c) => {
        c.classList.remove("active");
      });
      if (!isActive) {
        tab.classList.add("active");
        if (content) {
          content.classList.add("active");

          if (isMobileSafari()) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                content.scrollIntoView({ behavior: "smooth", block: "start" });
              }, 50);
            });
          }
        }
      }
    });
  });

  function isMobileSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && /iP(ad|hone|od)/.test(navigator.userAgent);
  }
});
